import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "11", cy: "11", r: "8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "21", x2: "16.65", y1: "21", y2: "16.65", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "8", x2: "14", y1: "11", y2: "11", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ZoomOut";
const ZoomOut = memo(themed(Icon));
export {
  ZoomOut
};
//# sourceMappingURL=zoom-out.js.map
